import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { UserModule } from 'src/app/user/user.module';
import { MaterialUiModule } from 'src/app/layout/material-ui/material-ui.module';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ClientLayoutComponent } from './layout/client-layout/client-layout.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { EmptyLayoutComponent } from './layout/empty-layout/empty-layout.component';
import { AddAnexoModalComponent } from './components/add-anexo-modal/add-anexo-modal.component';
import { PreparoComponent } from './components/preparo/preparo.component';

import { AssociarPacienteComponent } from './components/associar-paciente/associar-paciente.component';
import { AssociarPacienteLayoutComponent } from './layout/associar-paciente-layout/associar-paciente-layout.component';
import { AnexoComponent } from './components/anexo/anexo.component';
import { ClientModule } from './client/client.module';

@NgModule({
  declarations: [
    AppComponent,
    ClientLayoutComponent,
    AdminLayoutComponent,
    EmptyLayoutComponent,
    AssociarPacienteComponent,
    AssociarPacienteLayoutComponent,
    AddAnexoModalComponent
  ],
  imports: [
    ClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialUiModule,
    FormsModule,
    HttpClientModule,
    UserModule,
    FlexLayoutModule,
    MatSnackBarModule
  ],
  providers: [ 
      {  
        provide: LOCALE_ID,
        useValue: 'pt-BR'
      },
      {
        provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, 
        useValue: {
          duration: 2500
        }
      }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    AddAnexoModalComponent
  ]
})
export class AppModule { }
